export default [
  { value: "CHILD", key: "dependents.relations.child" },
  { value: "SPOUSE", key: "dependents.relations.spouse" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/enums/dependentRelations.js